const calculateItemSalePrice = (item, flag = false) => (
  item.salePrice - Math.min(item.systemDiscount / (flag ? 1 : item.quantity), 0)
)

export default calculateItemSalePrice